module.exports = __webpack_public_path__ + "static/media/country_ug.5ac3927e.webp";